<footer
  class="fixed bottom-0 left-0 right-0 bg-gradient-to-r from-gray-900 to-slate-800 border-t border-gray-700 h-8 z-50"
>
  <div class="px-6 h-full">
    <div class="flex justify-between items-center h-full">
      <!-- Left section -->
      <div class="flex items-center gap-3">
        <span class="text-xs text-gray-400">
          Copyright &copy; {{ currentYear }} QPilot, LLC.
        </span>
      </div>

      <!-- Center section - Version -->
      <div *ngIf="version" class="hidden sm:flex items-center">
        <!-- Tablet view - version without API -->
        <div
          class="inline-flex items-center px-2 py-0.5 rounded-full bg-emerald-900/50 text-xs font-medium text-emerald-300 border border-emerald-700/50 md:hidden"
        >
          <div class="w-1.5 h-1.5 bg-emerald-400 rounded-full mr-1.5"></div>
          {{ versionWithoutApi }}
        </div>
        <!-- Desktop view - version with API -->
        <div
          class="hidden md:inline-flex items-center px-2 py-0.5 rounded-full bg-emerald-900/50 text-xs font-medium text-emerald-300 border border-emerald-700/50"
        >
          <div class="w-1.5 h-1.5 bg-emerald-400 rounded-full mr-1.5"></div>
          {{ version }}
        </div>
      </div>

      <!-- Right section - Links -->
      <div class="flex items-center gap-4">
        <a
          href="https://qpilot.com/privacy-policy/"
          target="_blank"
          class="text-sm text-gray-300 hover:text-indigo-400 font-medium transition-colors duration-200"
          >Privacy Policy</a
        >
        <a
          [href]="termsConditionsUrl"
          target="_blank"
          class="text-sm text-gray-300 hover:text-indigo-400 font-medium transition-colors duration-200"
          >Terms of Service</a
        >
      </div>
    </div>
  </div>
</footer>
